export default "__VITE_ASSET__B6foRB9g__"